/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddCustomerCreditsRequestBody
 */
export interface AddCustomerCreditsRequestBody {
    /**
     * 
     * @type {number}
     * @memberof AddCustomerCreditsRequestBody
     */
    creditsCents: number;
    /**
     * 
     * @type {string}
     * @memberof AddCustomerCreditsRequestBody
     */
    description: string;
}

/**
 * Check if a given object implements the AddCustomerCreditsRequestBody interface.
 */
export function instanceOfAddCustomerCreditsRequestBody(value: object): value is AddCustomerCreditsRequestBody {
    if (!('creditsCents' in value) || value['creditsCents'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function AddCustomerCreditsRequestBodyFromJSON(json: any): AddCustomerCreditsRequestBody {
    return AddCustomerCreditsRequestBodyFromJSONTyped(json, false);
}

export function AddCustomerCreditsRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddCustomerCreditsRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'creditsCents': json['creditsCents'],
        'description': json['description'],
    };
}

export function AddCustomerCreditsRequestBodyToJSON(json: any): AddCustomerCreditsRequestBody {
    return AddCustomerCreditsRequestBodyToJSONTyped(json, false);
}

export function AddCustomerCreditsRequestBodyToJSONTyped(value?: AddCustomerCreditsRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'creditsCents': value['creditsCents'],
        'description': value['description'],
    };
}

